import { useContext } from 'react';
import UserInfoContext from '../contexts/UserInfoContext';
export function useUserInfo() {
  return useContext(UserInfoContext);
}